/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetHealthcareFacilityDto } from './GetHealthcareFacilityDto';
import {
    GetHealthcareFacilityDtoFromJSON,
    GetHealthcareFacilityDtoFromJSONTyped,
    GetHealthcareFacilityDtoToJSON,
} from './GetHealthcareFacilityDto';

/**
 * 
 * @export
 * @interface GetUserInHealthcareFacilityDto
 */
export interface GetUserInHealthcareFacilityDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserInHealthcareFacilityDto
     */
    id: string;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetUserInHealthcareFacilityDto
     */
    user?: GetUserDto | null;
    /**
     * 
     * @type {GetHealthcareFacilityDto}
     * @memberof GetUserInHealthcareFacilityDto
     */
    healthcareFacility?: GetHealthcareFacilityDto | null;
}

/**
 * Check if a given object implements the GetUserInHealthcareFacilityDto interface.
 */
export function instanceOfGetUserInHealthcareFacilityDto(value: object): value is GetUserInHealthcareFacilityDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetUserInHealthcareFacilityDtoFromJSON(json: any): GetUserInHealthcareFacilityDto {
    return GetUserInHealthcareFacilityDtoFromJSONTyped(json, false);
}

export function GetUserInHealthcareFacilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserInHealthcareFacilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': json['user'] == null ? undefined : GetUserDtoFromJSON(json['user']),
        'healthcareFacility': json['healthcareFacility'] == null ? undefined : GetHealthcareFacilityDtoFromJSON(json['healthcareFacility']),
    };
}

export function GetUserInHealthcareFacilityDtoToJSON(value?: GetUserInHealthcareFacilityDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'user': GetUserDtoToJSON(value['user']),
        'healthcareFacility': GetHealthcareFacilityDtoToJSON(value['healthcareFacility']),
    };
}

